<template>
  <v-container>
    <v-row class="pt-6" :dense="true">
      <v-col cols="2">
        <v-img
            height="48"
            :src="require('@/assets/logo.gif')"
            contain
            @click="$router.push('/')"
        />
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mobile?8:4">
        <v-text-field
            v-model="keyword"
            :placeholder="placeholder"
            :label="label"
            outlined
            clearable
            hide-details="auto"
            persistent-hint
            :dense="true"
            @blur="onBlur"
            @focus="onFocus"
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="">
        <v-btn
            text
            color="primary"
            depressed
            @click="onSearch()"
        >
          搜索
        </v-btn>
      </v-col>
      <v-row :justify="$vuetify.breakpoint.mobile?'start':'end'">
        <v-col cols="2" class="" align="end">
          <v-btn
              text
              color="primary"
              depressed
              @click="$router.push('/')"
          >
            首页
          </v-btn>
        </v-col>
        <v-col cols="2" class="">

          <v-btn
              v-if="!isLogin"
              text
              color="primary"
              depressed
              @click="$router.push('/login')"
          >
            登陆
          </v-btn>
          <v-btn
              v-else
              text
              color="primary"
              @click="onLogout()"
              depressed
          >
            退出登陆
          </v-btn>
        </v-col>
        <v-col cols="2" class="" align="end">

          <v-btn
              text
              color="primary"
              depressed
              @click="openUrl('https://www.wshine.com.cn')"
          >
            沃杉官网
          </v-btn>
        </v-col>
      </v-row>

    </v-row>
  </v-container>
</template>

<script>
import merge from 'webpack-merge';
import {mapMutations, mapState} from "vuex";
import auth from '@/utils/auth'
import * as userApi from "@/servers/user";
import * as videoApi from "@/servers/video";

export default {
  name: 'CoreHeader',
  props: {
    searchPage: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    keyword: "",
    hotKeyword: "",
    placeholder: "请输入关键词",
    label: "",
    keywords: [],
    items: ["退出登陆"],
    isLogin: false
  }),
  computed: {
    ...mapState(['userName']),

  },
  methods: {
    ...mapMutations(['onVideoSearch']),
    onBlur() {
      //失去焦点
      this.label = "";
    },
    onFocus() {
      //得到焦点
      this.label = "搜索";
    },
    onIsLogin() {
      userApi.isLogin().then(res => {
        if (res == 1) {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
      });
    },
    onLogout() {
      userApi.logout();
      // this.$router.push({path: '/'})
      auth.logout()
    },
    onLoadSearchKeyword() {
      videoApi.hotVideoNameList().then(res => {
        this.keywords = res;
      });
      console.log("this.keywords->" + JSON.stringify(this.keywords))
    },
    switchKeyword() {
      if (this.keywords.length <= 0) {
        return;
      }
      this.placeholder = this.keywords[Math.floor(Math.random() * this.keywords.length)];
    },
    switchKeywordTimer() {
      return setInterval(() => {
        this.switchKeyword();
      }, 5000)
    },
    openUrl(href) {
      window.open(href, "_blank");
    },
    onSearch() {
      let that = this;
      let k = '';
      if (that.keyword == '') {
        k = that.placeholder;
      } else {
        k = that.keyword;
      }
      setTimeout(() => {
        that.onVideoSearch({keyword: k, salt: Math.random()})
      }, 500)

      if (that.searchPage) {
        this.$router.push({
          undefined,
          query: merge(this.$route.query, {
            'keyword': that.k,
          })
        })
      } else {
        this.$router.push({path: '/search', query: {'keyword': k}})
      }

    }
  },
  watch: {
    keywords() {
      this.switchKeywordTimer()
    }
  },
  destroyed() {
    clearInterval(this.switchKeywordTimer);
  },
  created() {
    this.onLoadSearchKeyword();
    this.onIsLogin();
    let query = this.$route.query;
    if (query && query.keyword) {
      this.keyword = query.keyword;
      this.onSearch();
    }
  },
}
</script>
